import * as React from 'react';

type IconButtonProps = {
  title?: string;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
  onTouchEnd?: React.TouchEventHandler<HTMLDivElement>;
  icon: React.ReactNode;
};

export function IconButton({
  title,
  disabled,
  className = '',
  icon,
  onClick,
  onTouchEnd
}: IconButtonProps) {
  const disabledClasses = disabled
    ? 'pointer-events-none cursor-not-allowed text-gray-400'
    : 'pointer-events-auto cursor-pointer text-gray-800';

  return (
    <div
      className={`h-4 ${disabledClasses} ${className}`}
      tabIndex={0}
      role="button"
      id={title}
      title={title}
      onClick={onClick}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          onClick();
        }
      }}
      aria-disabled={disabled}
      onTouchEnd={onTouchEnd}>
      {icon}
    </div>
  );
}
